import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { TypeLieuComponent } from './typeLieu/type-lieu.component';
import { TypeCoordComponent } from './typeCoord/type-coord.component';
import { TypeCrJugementComponent } from './typeCrJugement/type-cr-jugement.component';
import { LotMarcheComponent } from './lotMarche/lot-marche.component';
import { TypeAutresInfosATTRComponent } from './typeAutresInfosATTR/type-autres-infosATTR.component';
import { TypePersComponent } from './typePers/type-pers.component';
import { AttributionFromMAPAComponent } from './attributionFromMAPA/attribution-fromMAPA.component';
import { TypeAttributionMarcheLotComponent } from './typeAttributionMarcheLot/type-attribution-marche-lot.component';
import { TypeAdresseComponent } from './typeAdresse/type-adresse.component';
import { OffresComponent } from './offres/offres.component';
import { AttributionComponent } from './attribution/attribution.component';
import { TypeMontantComponent } from './typeMontant/type-montant.component';
import { MontantAnnuelComponent } from './montantAnnuel/montant-annuel.component';
import { AvisInitialTypeComponent } from './avisInitialType/avis-initial-type.component';
import { TypeOuiNonComponent } from './typeOuiNon/type-oui-non.component';
import { TypeAdresseCompleteMoraleComponent } from './typeAdresseCompleteMorale/type-adresse-complete-morale.component';
import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { CriterePondereComponent } from './criterePondere/critere-pondere.component';
import { DescriptionReduiteComponent } from './descriptionReduite/description-reduite.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { MarcheNegocieComponent } from './marcheNegocie/marche-negocie.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { TypeResultatAttributionComponent } from './typeResultatAttribution/type-resultat-attribution.component';
import { SousTraitanceOuiComponent } from './sousTraitanceOui/sous-traitance-oui.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { TypeTravauxComponent } from './typeTravaux/type-travaux.component';
import { TypeFournituresComponent } from './typeFournitures/type-fournitures.component';
import { FormMAPA_ATComponent } from './formmapa/form.mapa.at.component';
import { Step1Component } from './steps/step1/step1.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { Step5Component } from './steps/step5/step5.component';
import { Step6Component } from './steps/step6/step6.component';
import { FormmapaCommonModule } from '../common/formmapa.module';

@NgModule({
  declarations: [
    TypeLieuComponent,
    TypeCoordComponent,
    TypeCrJugementComponent,
    LotMarcheComponent,
    TypeAutresInfosATTRComponent,
    TypePersComponent,
    AttributionFromMAPAComponent,
    TypeAttributionMarcheLotComponent,
    TypeAdresseComponent,
    OffresComponent,
    AttributionComponent,
    TypeMontantComponent,
    MontantAnnuelComponent,
    AvisInitialTypeComponent,
    TypeOuiNonComponent,
    TypeAdresseCompleteMoraleComponent,
    TypeCPVClassComponent,
    CriterePondereComponent,
    DescriptionReduiteComponent,
    TypeObjCPVComponent,
    MarcheNegocieComponent,
    TypeVoieComponent,
    TypeResultatAttributionComponent,
    SousTraitanceOuiComponent,
    ProcedureComponent,
    TypeTravauxComponent,
    TypeFournituresComponent,
    FormMAPA_ATComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    Step5Component,
    Step6Component],
  exports: [
    FormMAPA_ATComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    FormmapaCommonModule
  ]
})
export class FormmapaAttributionModule {
}
